import React, { useEffect, useState } from 'react';
import { connect } from '@common/components/base.component';
import { socketIO } from '@common/socket/socket';
import { getUrlByName } from '@common/router/router';
import { addWarning, addSuccess, addError } from '@common/helpers/toastr.helper';
import { TipoNotificacao } from '@common/components/navbar/notification/enums/navbar.notification.enum';
import { systemList } from './notification.resource';
import navbarSelectors from '@common/store/navbar/navbar.selectors';
import navbarActions from '@common/store/navbar/navbar.actions';
import InfiniteScroll from 'react-infinite-scroll-component';
import DateFormat from '@common/components/formats/date.format';
import sessionStorageUtils from '@common/helpers/sessionStorage.utils';
import relatorioGerencialHelper from '@common/components/relatorioGerencial/emissao/relatorioGerencialHelper';

export function NavbarNotification(props) {
  const [page, setPage] = useState(1);
  const { navbarActions, routerManager, navbarSelectors } = props;
  const { pagesNotification, numberNotification } = navbarSelectors;

  const hasMore = numberNotification == 0 ? false : true;
  const idSistema = sessionStorageUtils.getSistema();

  useEffect(() => {
    socketIO().off('atualizaNotificacao');
    socketIO().on('atualizaNotificacao', (newNotification) => {
      navbarActions.getTotalNotification();
      navbarActions.getAllNotification(page);
      navbarActions.getNewNotification(newNotification);
      createToast(newNotification);
    });
  }, [page]);

  function createToast(notification) {
    if (notification) {
      if (notification.TipoNotificacao == TipoNotificacao.Sucesso)
        addSuccess('', notification.Mensagem, () => this.openNotification(notification, true));
      if (notification.TipoNotificacao == TipoNotificacao.Alerta)
        addWarning('', notification.Mensagem, () => this.openNotification(notification, true));
      if (notification.TipoNotificacao == TipoNotificacao.Erro)
        addError('', notification.Mensagem, () => this.openNotification(notification, true));
    }
  }

  function openNotification(notification, isToast) {
    if (utilizaNovaAba(notification.Link)) return;

    navbarActions.readNotification({ notification, page });
    if (isToast) {
      if (notification.Link.indexOf('http') > -1) {
        window.location.href = notification.Link;
      } else if (notification.Link.startsWith('/')) {
        routerManager.redirect({ url: notification.Link });
      } else {
        routerManager.redirect({ name: notification.Link });
      }
    }
  }

  function getLink(link) {
    if (link) {
      var linkIsInSystem = getUrlByName(link);

      if (linkIsInSystem) return `#${linkIsInSystem}`;

      if (link.includes('http://') || link.includes('https://')) {
        return relatorioGerencialHelper.validLinkReport(link);
      }

      return `#${link}`;
    }
    return null;
  }

  function showMore() {
    let newPage = page + 1;
    setPage(newPage);
    navbarActions.getPagesNotification(newPage);
  }

  function utilizaNovaAba(link) {
    return link?.toLowerCase()?.includes('fileserver');
  }

  return (
    <li className="dropdown-submenu">
      <i className="fa fa-bell" />

      <a>Notificações</a>

      <ul className="dropdown-menu">
        <div className="notification-header text-center">
          <span>Notificações</span>
        </div>

        <div id="scrollableDiv" className="areaNotificacao">
          <InfiniteScroll
            dataLength={pagesNotification.length}
            next={showMore}
            hasMore={hasMore}
            scrollThreshold={0.95}
            scrollableTarget="scrollableDiv"
            loader={
              pagesNotification.length >= 5 && (
                <div key={0}>
                  <li className="notificacao-item" key="0">
                    <div className="notificacao-item-detail text-center">
                      <img src={system_routes.Common.Url + '/images/loading-signup.gif'} />
                    </div>
                  </li>
                </div>
              )
            }
          >
            <div>
              {(pagesNotification &&
                pagesNotification.length > 0 &&
                pagesNotification.map((item, index) => (
                  <li className="notificacao-item" key={`${index} - ${item.Id}`}>
                    <a
                      onClick={() => openNotification(item, item.TipoNotificacao != 4)}
                      href={getLink(item.Link)}
                      target={utilizaNovaAba(item.Link) ? 'blank' : undefined}
                    >
                      <div
                        className={
                          (!item.DataHoraLeitura && 'notificacao-item-detail notificacao-item-new') ||
                          'notificacao-item-detail'
                        }
                        dangerouslySetInnerHTML={{ __html: item.Mensagem }}
                      />

                      <div className="notificacao-item-footer">
                        <span>
                          <DateFormat value={item.DataHora} />
                        </span>
                        <span className="float-right">{item.Origem}</span>
                      </div>
                    </a>
                  </li>
                ))) || (
                <li className="text-center">
                  <span className="dataHoraLeitura">Não há notificações.</span>
                </li>
              )}
            </div>
          </InfiniteScroll>
        </div>

        {systemList.includes(idSistema) && (
          <div
            className="notification-footer text-center"
            onClick={() => routerManager.redirect({ name: 'notificacao' })}
          >
            <span>Ver Todas</span>
          </div>
        )}
      </ul>
    </li>
  );
}

export default connect({
  selectors: {
    navbarSelectors,
  },
  actions: {
    navbarActions,
  },
})(NavbarNotification);
